var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhase4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1484.5 389L1507.5 383H1523.5L1532.5 391.5L1529.5 426.5L1574.5 417L1585 426.5L1649 411L1681 442.5V454.5L1657.5 459.5L1666.5 479H1675L1686 486.5V505.5L1696 515V539.5L1752.5 584.5V597L1765.5 608L1771.5 605H1784L1798 621.5L1801 630V634L1803.5 644.5L1602 697.5L1591 684.5L1507.5 689.5L1424 518L1430 479L1440 473L1444.5 422.5H1462L1471 431.5V417L1482 408L1479.5 400L1484.5 389Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase4);
export default __webpack_public_path__ + "static/media/phase_4.624189aec6e5a5ecba13e39ff73b7abd.svg";
export { ForwardRef as ReactComponent };